import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AppBar from '@material-ui/core/AppBar';
import InputBase from '@material-ui/core/InputBase';
import Toolbar from '@material-ui/core/Toolbar';
import SearchIcon from '@material-ui/icons/Search';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { withStyles } from '@material-ui/core/styles';
import SideMenu from './SideMenu';
import links from 'utils/links';
import CreateButton from './AddNewDialogs';
import userInfo from 'utils/userInfo';

const inputFocusStyle = theme => ({
  backgroundColor: fade(theme.palette.common.white, 0.15),
  color: 'initial',
  borderRadius: theme.shape.borderRadius,
  borderColor: theme.palette.primary.dark,
  borderStyle: 'solid',
  borderWidth: 1,
  paddingRight: theme.spacing.unit * 2 + 24,
  width: 100,
  [theme.breakpoints.up('sm')]: {
    width: 320,
  },
  '&:hover': {
    backgroundColor: fade(theme.palette.common.white, 0.25),
  },
});

const styles = theme => ({
  searchIcon: {
    right: theme.spacing.unit,
    pointerEvents: 'none',
  },
  inputInput: {
    color: 'transparent',
    width: 24, // same as width of search icon
    '&:focus': inputFocusStyle(theme),
    // TODO: placeholder-shown is unsupported in Edge
    '&:not(:focus)&:not(:placeholder-shown)': inputFocusStyle(theme),
    padding: theme.spacing.unit,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.easeOut,
    }),
  },
});

class SearchBar extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  state = {
    searchText: '',
  };

  handleKeyPress(e) {
    let { history } = this.props;
    if (e.charCode === 13) {
      e.target.blur();
      history.push(links.searchLink(e.target.value));
      this.setState({ searchText: '' });
    } else if (e.keyCode === 13) {
      e.target.blur();
      history.push(links.searchLink(e.target.value));
      this.setState({ searchText: '' });
    }
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={'relative mx-4'}>
        <InputBase
          placeholder="Search"
          classes={{
            input: classes.inputInput,
          }}
          type="search"
          value={this.state.searchText}
          onChange={e => {
            this.setState({ searchText: e.target.value });
          }}
          onKeyPress={this.handleKeyPress}
          ref={this.searchRef}
        />
        <div
          className={classNames(
            'absolute h-full pin-b flex justify-center items-center',
            classes.searchIcon
          )}
        >
          <SearchIcon />
        </div>
      </div>
    );
  }
}

function NavBar(props) {
  const { classes, history } = props;

  return (
    <AppBar position="sticky">
      <Toolbar>
        <Link to={links.home()}>
          <img
            src="/img/logo.png"
            alt="Talking Street"
            width={48}
            height={48}
            // onClick={this.handleChange}
          />
        </Link>
        <div className="flex-grow" />
        <SearchBar classes={classes} history={history} />
        <SideMenu history={history} />
      </Toolbar>
      {userInfo.doesUserExist() ? <CreateButton /> : ''}
    </AppBar>
  );
}

NavBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NavBar);
